import axios from "axios";
import config from "./config.js";

export default axios.create({  
  baseURL: config.walletApi,
  headers: {
    "Content-type": "application/json"
  }
});